import { RatingBagContainer, RatingBagActiveContainer, RatingBarStars } from './styled'
import star from '../assets/star.svg'

const RatingBar = ({ score }: { score: number }) => {
    const maxScore = 10; // Максимальный балл
    const starCount = 10; // Количество звезд
  
    // Создание массива звезд с учетом заполненных и незаполненных
    const stars = Array.from({ length: starCount }, (_, index) => (
        <img key={index} src={star} alt='star' />
    ));
  
    return (
      <div>
        <RatingBagContainer>
          <RatingBagActiveContainer width={`${(score / maxScore) * 100}%`}>
            <RatingBarStars>{stars}</RatingBarStars>
          </RatingBagActiveContainer>
        </RatingBagContainer>
      </div>
    );
  };

  export default RatingBar;